<template>
  <div
    class="home-sales"
    :class="{ 'camping-sales': isCamping }"
    v-if="isLoaded"
  >
    <div class="container">
      <h2
        class="relative-section text-center section-title font-balo font-bold"
      >
        <span>{{ $t("app.profiter") }}</span>
        <b>{{ $t("app.Nos offres du moment") }}</b>
      </h2>
      <div class="slider-for" v-if="rooms.length > 0">
        <slick
          :options="slickOptions"
          ref="slick"
          @onInit="reInit"
          class="product-list slider-call slider-default camping-sales-slider"
        >
          <div class="product-item" v-for="(item, index) in rooms" :key="index">
            <a class="image-fit" @click.prevent="onGotoRoomPromotion(item)">
              <img
                :src="getImageUri(item.ImageIds[0])"
                v-if="item.ImageIds.length"
                alt
              />
            </a>
            <div class="info-text">
              <h3>
                <a @click.prevent="onGotoRoomPromotion(item)">{{
                  getTranslate(item.Name)
                }}</a>
                <div class="location">{{ item.camping.name }}</div>
              </h3>
            </div>
            <div class="info-price">
              <div class="time text-center">
                <b>
                  <i>{{ getRoomBookTime(item) }}</i>
                </b>
              </div>
              <div class="price text-center">
                {{ $t("app.à partir de") }}
                <b>
                  {{ getPrice(item) }}
                  {{ currency.symbol }}
                </b>
              </div>
              <div class="text-center">
                <a
                  @click.prevent="onGotoRoomPromotion(item)"
                  class="btn font-bold"
                  >{{ $t("app.j’en profite") }}</a
                >
              </div>
            </div>
          </div>
        </slick>
      </div>
    </div>
  </div>
</template>
<script>
import Slick from "vue-slick";
import { CDN_MEWS_MEDIA } from "@/api/config";
import { mapState, mapMutations, mapActions } from "vuex";
import { get, find, first } from "lodash";
import moment from "moment";
import {
  formatBookDate,
  numberOfNightsBetweenDates
} from "@/helper/calculateDays";
import Vue from "vue";
import { ADULT_COUNT_DEFAULT } from "@/api/config";
export default {
  name: "ProductSalesSlide",
  components: { Slick },
  props: ["isCamping"],
  computed: {
    ...mapState({
      homePromotions: state => get(state, "hotels.homePromotions", []),
      currency: state => get(state, "app.currency", {})
    })
  },
  mounted() {
    this.isLoaded = true;
    this.rooms = this.homePromotions;
    this.getPromotions().then(() => {
      this.rooms = this.homePromotions;
      this.reInit();
    });
  },
  methods: {
    ...mapMutations("hotels", ["setFilter"]),
    ...mapActions("hotels", ["getPromotions"]),

    getImageUri(image) {
      return `${CDN_MEWS_MEDIA}/Image/${image}?Mode=Fit&Height=161`;
    },
    getTranslate(object) {
      if (this.lang === "fr" && get(object, "fr-FR")) {
        return get(object, "fr-FR");
      }
      return get(object, "en-US");
    },
    getRoomBookTime(room) {
      const dateFrom = moment(room.promotionStartDate, "DD-MM-YYYY").format(
        "ddd DD"
      );
      const dateTo = moment(room.promotionEndDate, "DD-MM-YYYY").format(
        "ddd DD"
      );
      const totalDate = numberOfNightsBetweenDates(
        moment(room.promotionStartDate, "DD-MM-YYYY"),
        moment(room.promotionEndDate, "DD-MM-YYYY")
      );
      if (totalDate > 1) {
        return `${this.$i18n.t("app.Du")} ${dateFrom} ${this.$i18n.t(
          "app.au"
        )} ${dateTo}. (${totalDate} ${this.$i18n.t("app.nuits")})`;
      } else {
        return `${this.$i18n.t("app.Du")} ${dateFrom} ${this.$i18n.t(
          "app.au"
        )} ${dateTo}. (${totalDate} ${this.$i18n.t("app.nuit")})`;
      }
    },
    getPrice(room) {
      const RoomCategoryAvailabilities = get(
        room,
        "roomCategoryAvailabilities.RoomCategoryAvailabilities"
      );
      if (RoomCategoryAvailabilities) {
        const roomOccupancyAvailabilities = first(
          find(
            RoomCategoryAvailabilities,
            item => item.RoomCategoryId === room.Id
          ).RoomOccupancyAvailabilities
        );
        const roomPrice = get(
          roomOccupancyAvailabilities,
          `Pricing.0.Price.TotalAmount.${this.currency.code}.GrossValue`
        );
        // const promotionValue = room.promotionValue
        //     ? room.promotionValue
        //     : 0;
        return roomPrice; //round(roomPrice - (roomPrice * promotionValue) / 100, 2);
      }
    },
    onGotoRoomPromotion(room) {
      let dataReferences = {
        camping: get(room, "camping.id"),
        dateFrom: formatBookDate(moment(room.promotionStartDate, "DD-MM-YYYY")),
        dateTo: formatBookDate(moment(room.promotionEndDate, "DD-MM-YYYY")),
        type: get(room, "type"),
        categorie: get(room, "category"),
        adult: ADULT_COUNT_DEFAULT,
        child: 0,
        child1: 0,
        voucher: room.promotionCode
      };
      this.setFilter(dataReferences);
      this.$router.push(`/room/${room.id}`);
    },
    reInit() {
      Vue.nextTick(() => {
        if (this.$refs.slick) {
          this.$refs.slick.reSlick();
        }
      });
    }
  },
  data() {
    return {
      isLoaded: false,
      rooms: [],
      slickOptions: {
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: true,
        autoplay: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    };
  },
  watch: {
    homePromotions: function(homePromotions) {
      this.rooms = homePromotions;
      this.reInit();
    }
  }
};
</script>
